'use client'

import Link from 'next/link'
import type { ComponentProps } from 'react'

import { track } from '@/lib/analytics/track'

type TrackedLinkProps = ComponentProps<typeof Link> & {
  event: string
  eventProperties?: Record<string, string | number | boolean | null>
}

export function TrackedLink({
  event,
  eventProperties,
  onClick,
  ...props
}: TrackedLinkProps) {
  return (
    <Link
      {...props}
      onClick={clickEvent => {
        track(event, eventProperties)
        onClick?.(clickEvent)
      }}
    />
  )
}
